import React from "react";
import { withRouter } from "react-router-dom";

const CustomBreadCrumb = ({ location }) => {
  // Get route path segments
  const getSegments = (location) => {
    return location.pathname
      .split("/")
      .splice(1)
      .map((segment) => segment.replace(/\d|-/g, " "));
  };
  return (
    <div className="custom-breadcrumb">
      <ul>
        {getSegments(location).map((segment, index) => (
          <li key={index}>{segment}</li>
        ))}
      </ul>
    </div>
  );
};

export default withRouter(CustomBreadCrumb);
